var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{staticClass:"tag",attrs:{"outlined":"","loading":_vm.loading,"value":_vm.content,"auto-grow":"","background-color":"white"}})}
var staticRenderFns = []

export { render, staticRenderFns }